import type { ConceptDef } from '../types';

export const sequenceNumbers: ConceptDef = {
  kind: 'sequenceTap',
  id: 'sequence-numbers',
  label: 'Sequence Numbers',
  category: 'Sequencing',
  description: 'Tap numbers in order from 1 to 5.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Tap 1 to 5 in order.', items: ['1', '2', '3', '4', '5'] },
      { label: 'Tap 1 to 6 in order.', items: ['1', '2', '3', '4', '5', '6'] },
    ],
  },
};
